import React, {Component} from 'react';
import '../careers-services/careers-services.scss';
import graph_ql from '../../images/graph_ql.png';
import aws_logo from '../../images/aws_logo.png';
import python from '../../images/python.png';
import react_logo from '../../images/react_logo.png';
import Carousel from 'react-elastic-carousel'

class CareersServices extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [
                {id: 1, title: 'GraphQL is an open-source data query and manipulation language for APIs, and a runtime for fulfilling queries with existing data. GraphQL is a syntax that describes how to ask for data, and is generally used to load data from a server to a client.',img:graph_ql},
                {id: 1, title: 'Partnered with AWS, which is the Market Leader. Exploring all the latest services in deployment(FARGATE) and analysis front. Implementing Anomaly detection using ML services(SageMaker/Deeplens).',img:aws_logo},
                {id: 1, title: 'Python is an interpreted, high-level, general-purpose programming language. Python for developing desktop GUI applications, websites and web applications.',img:python},
                {id: 1, title: 'React is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.',img:react_logo},
              ]
        }
    }

    render() {
        return(
            <div className="careers_services_wrapper">
                <div className="container">
                    
                    <Carousel verticalMode enableAutoPlay itemsToShow={1} showArrows={false} style={{height:'100%'}}>
                    {
                        this.state.items.map((each,index) => {
                            return (
                                <ul className="flex_wrap_careers">
                                    <li>
                                        <div className="carousel_img">
                                            <img src={each.img} alt="Banner Image"></img>
                                        </div>
                                        <p>{each.title}</p>
                                    </li>
                                </ul>
                            )
                        })
                    }
                    </Carousel>
                </div>
            </div>
        )
    }
}

export default CareersServices;